import Vue from "vue";
import Vuex from "vuex";

import UserModule from "./modules/user";
import ResponsiveModule from "./modules/responsive";
import ModalModule from "./modules/modal";
import ConstantModule from "./modules/constant";
import GlobalModule from "./modules/global";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        userModule: UserModule,
        responsiveModule: ResponsiveModule,
        modalModule: ModalModule,
        constantModule: ConstantModule,
        globalModule: GlobalModule
    },
});
